//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getFieldConfig} from '../source.js';
import dynamicSingleField from './dynamic-single-field';
import dynamicMultField from './dynamic-mult-field';
export default {
  name: "source-material",
  props:['sourceDto','defaultPar','priceTemplateList','sourceExtendConfig'],
  components:{
    dynamicSingleField,
    dynamicMultField
  },
  data(){
    return {
      offerFieldList:[],
      inquiryFieldList:[]
    }
  },
  methods:{
    changeShow(data){
      if(data.cellShow){
        this.$set(data,'cellShow',false);
        return;
      }
      this.$set(data,'cellShow',true);
    },
    changeSelected(data,str){
      this.$set(data,'selectShow',str);
    },
    getDynamicField(){
      if(this.sourceDto.priceTemplete){
        this.offerFieldList = getFieldConfig(this.sourceDto.priceTemplete).offerFieldList;
        this.inquiryFieldList = getFieldConfig(this.sourceDto.priceTemplete).inquiryFieldList;
      }
    },
    viewField(field,dynamicData){
      this.$refs.multMatDynamic.initData(field,dynamicData);
    }
  },
  mounted(){
    this.getDynamicField();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-common-module/source-material.vue